import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { LoginService } from '../services/login.service';
import { CasherService } from '../services/casher.service';

@Injectable({
  providedIn: 'root'
})
export class CashRegisterGuard implements CanActivate, CanActivateChild {

  constructor(private router: Router, private loginService:LoginService,private casherService:CasherService) {
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      const token = localStorage.getItem('ACCESS_TOKEN');
      let isSupervisor = null;
      if(this.casherService.getSupervisor != null){
        isSupervisor = this.casherService.getSupervisor;
      }else{
        isSupervisor = localStorage.getItem('SUPERVISOR') === 'true';
      }
      
      if(token != null){
        this.loginService.refresh();
      }
      if (!this.loginService.isAuthenticateds()) {
        this.router.navigate(['/user-pages/login']);
        return false;
      }

      if(!this.loginService.hasAnyRole(['ADMIN', 'SELLER', 'SELLER-ADMIN', 'CASHIER','CASHIER-SELLER'])){
        this.router.navigate(['/dashboard']);
        return false;
      }
      
      // Check if trying to access report URL
      if (state.url.includes('cash-register/report')) {
        const userRole = localStorage.getItem('ROLE');
        if (userRole !== 'ADMIN' && !isSupervisor) {
          this.router.navigate(['/dashboard']);
          return false;
        }
      }
      
      return true;
  }
  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      const token = localStorage.getItem('ACCESS_TOKEN');
      let isSupervisor = null;
      if(this.casherService.getSupervisor != null){
        isSupervisor = this.casherService.getSupervisor;
      }else{
        isSupervisor = localStorage.getItem('SUPERVISOR') === 'true';
      }
      
      if(token != null){
        this.loginService.refresh();
      }
      if (!this.loginService.isAuthenticateds()) {
        this.router.navigate(['/user-pages/login']);
        return false;
      }
      
      if(!this.loginService.hasAnyRole(['ADMIN', 'SELLER', 'SELLER-ADMIN', 'CASHIER','CASHIER-SELLER'])){
        this.router.navigate(['/dashboard']);
        return false;
      }
      
      if (state.url.includes('cash-register/report')) {
        const userRole = localStorage.getItem('ROLE');
        if (userRole !== 'ADMIN' && !isSupervisor) {
          this.router.navigate(['/dashboard']);
          return false;
        }
      }
      
      return true;
  }

}
